import { getSessionId } from "owa-config";
import { fetchIdsFromMsGraph } from "./fetchIdsFromMsGraph";

import type { GraphUsersResponse } from "../types/GraphUsersResponse";

const GRAPH_GROUP_SIZE = 200;

export async function getMRIsFromGraphInBulk(smtps: string[]): Promise<GraphUsersResponse[]> {
    const mrisToReturn: GraphUsersResponse[] = [];
    const correlationId = getSessionId();
    
    if (smtps) {
        // Break up the emails into groups of 200 to avoid hitting the max url length
        const groups = [];
        if (smtps.length > GRAPH_GROUP_SIZE) {
            for (let i = 0; i < smtps.length; i += GRAPH_GROUP_SIZE) {
                groups.push(smtps.slice(i, i + GRAPH_GROUP_SIZE));
            }
        }
        else {
            groups.push(smtps);
        }
        
        // Fire off requests for each group in parallel
        const responsePromises = [];
        for (const group of groups) {
            // Build string with all the smtps to search for this group
            const smtpsToQueryString = buildStringWithSmtpsToQuery(group);
            // If the smtpsToQueryString is over 10000 chars, we need to break it up into two groups
            if (smtpsToQueryString.length > 10000) {
                const half = Math.floor(group.length / 2);
                const firstHalf = group.slice(0, half);
                const secondHalf = group.slice(half);
                groups.push(firstHalf, secondHalf);
            }
            else {
                responsePromises.push(fetchIdsFromMsGraph(smtpsToQueryString, correlationId));
            }
        }
        
        // Wait for all the responses to come back.
        const results = await Promise.allSettled(responsePromises);
        results.forEach(result => {
            if (result.status === "fulfilled") {
                const response = result.value;
                if (response) {
                    mrisToReturn.push(...response);
                }
            }
        });
    }
    return mrisToReturn;
}

function buildStringWithSmtpsToQuery(smtps: string[]): string {
    const smtpsToQuery = smtps.map(smtp => `"${encodeURIComponent(smtp)}"`).join(",");
    return smtpsToQuery;
}
